import { memo } from "react";
import getBackgroundColor from "../../../../../../../helpers/getBackgroundColor";
import Image from "../../../../../../Elements/Image/Image";
import { useContent } from "../../../../../../../contexts/contentContext/contentContext";

import styles from "./styles.module.scss";

interface InboxIconI {
  profilePhotoUrl: string;
  fullName: string;
  senderEmail: string;
}

/**
 * Represents an icon component for the inbox.
 * @param {InboxIconI} props - The props for the InboxIcon component.
 * @returns {JSX.Element} The rendered InboxIcon component.
 */

const InboxIcon = memo((props: InboxIconI) => {
    const { profilePhotoUrl, fullName, senderEmail } = props;
    const { getTextByKey } = useContent();

    return profilePhotoUrl ? (
        <Image
            src={profilePhotoUrl}
            className={styles.profilePhoto}
            alt={`${fullName} ${getTextByKey("profile-photo")}`}
        />
    ) : (
        <span
            className={`${styles.profileLabel} ${styles.profilePhoto}`}
            style={{ backgroundColor: getBackgroundColor(fullName) as string }}
        >
            {fullName?.slice(0, 1) || senderEmail?.slice(0, 1)}
        </span>
    );
});

export default InboxIcon;
